import { useMemo } from 'react';
import { useAppSelector } from '../../../../common/hooks/redux';
import { toUserProfileView } from '../../application/mapUserProfile';
import { useGetProfileQuery } from '../../infrastructure/api/user.api';

export function useUserProfile() {
  const isAuthenticated = useAppSelector(
    state => state.auth?.status === 'authenticated',
  );
  const authUser = useAppSelector(state => state.auth?.user);
  const storedProfile = useAppSelector(state => state.userProfile?.profile);
  const { data, isLoading, isFetching, isError } = useGetProfileQuery(
    undefined,
    { skip: !isAuthenticated },
  );

  const profile = data ?? storedProfile ?? null;
  const view = useMemo(
    () => toUserProfileView(profile, authUser),
    [profile, authUser],
  );

  return {
    profile,
    view,
    isLoading: isAuthenticated && isLoading && !profile && !authUser,
    isFetching,
    isError,
  };
}
